import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c2c556a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "demo-image" }
const _hoisted_2 = { class: "block" }


import { defineComponent, defineProps, onMounted, ref } from 'vue'
import { rootShowImagedPath } from '../config'

const __default__ = defineComponent({
  name: 'ImageItem'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  dataValue: {
    type: String,
    require: true
  }
},
  setup(__props) {

const props = __props

const refImageUrl = ref('')

onMounted(async () => {
  if ((props.dataValue.startsWith('http://') || props.dataValue.startsWith('https://'))) {
    refImageUrl.value = props.dataValue
  } else {
    refImageUrl.value = rootShowImagedPath + props.dataValue
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        style: {"width":"400px"},
        src: refImageUrl.value,
        fit: "fill"
      }, null, 8, ["src"])
    ])
  ]))
}
}

})